module.exports = __webpack_public_path__ + "img/智能批改助手公众号.046637c3.jpeg";